<!-- Flying bat animation - Halloween theme -->
@if (showBatAnimation() && !isFaqScreenActive()) {
  <div class="flying-bat"></div>
}

@switch (animationType()) {
  <!-- Snowfall animation - Winter theme -->
  @case ('snow') {
    @if (!isFaqScreenActive()) {
      <div class="snowfall-container" [class.fade-out-animation]="hasMessages()">
        @for (particle of particles(); track particle.id) {
          <div
            class="snowflake-wrapper"
            [style.left.%]="particle.x"
            [style.animation-duration.s]="particle.duration"
            [style.animation-delay.s]="particle.delay">
            <coin-snowflake
              [size]="particle.size"
              [variant]="particle.variant" />
          </div>
        }
      </div>
    }
  }

  <!-- Star animation - Ramadan theme -->
  @case ('star') {
    @if (!isFaqScreenActive()) {
      <div class="star-container" [class.fade-out-animation]="hasMessages()">
        @for (particle of particles(); track particle.id) {
          <div
            class="snowflake-wrapper"
            [style.left.%]="particle.x"
            [style.animation-duration.s]="particle.duration"
            [style.animation-delay.s]="particle.delay">
            <coin-star [size]="particle.size" />
          </div>
        }
      </div>
      <div class="bottom-pattern ramadan-pattern"></div>
    }
  }

  <!-- Lantern animation - Lunar New Year theme -->
  @case ('lantern') {
    @if (!isFaqScreenActive()) {
      <div class="lantern-container" [class.fade-out-animation]="hasMessages()">
        @for (particle of particles(); track particle.id) {
          <div
            class="lantern-wrapper"
            [style.left.%]="particle.x"
            [style.animation-duration.s]="particle.duration"
            [style.animation-delay.s]="particle.delay">
            <coin-lantern [size]="particle.size" />
          </div>
        }
      </div>
    }
  }
}
